<template>
  <div>
    <form v-on:submit.prevent="newSearchQuery">
      <div class="search-form">
        <div class="search-form__box search-form__box--select">
          <span class="select select--search">
            <select v-model="newSearchParamsParam">
              <option v-for="param in $lang.search.form.select.params" v-bind:value="param.val">{{ param.name }}</option>
            </select>
          </span>
        </div>
        <div class="search-form__box search-form__box--input suggestion" v-click-outside="onClickOutside">
          <input v-model="newSearchParamsKey" class="input--search" type="text" v-bind:placeholder="$lang.search.form.input.placeholder" v-on:keydown="autocompleteKeyHandler">
          <ul v-if="suggestions && suggestions.length > 0 && !activeAutocompleteDropdown && newSearchParamsKey" class="suggestions__list">
            <li v-for="(suggestion,index) in suggestions" class="suggestions__list--item suggestion">
              <a ref="autocompleteList" v-bind:data-autocomplete="index" class="suggestion__anchor" v-html="autocompleteHighlightLetters(suggestion, activeSuggestTmp)" v-on:click="autocompleteSetSuggestion(suggestion)" v-on:mouseenter="autocompleteListMouseEnter($event)"  v-on:mouseleave="autocompleteListMouseLeave($event)"></a>
            </li>
          </ul>
        </div>
        <div class="search-form__box search-form__box--button">
          <button class="button--search" type="submit" v-bind:disabled="!newSearchParamsKey" v-bind:title="$lang.search.form.button.search">
            <img src="static/img/search.svg">
          </button>
        </div>
      </div>
    </form>

  </div>
</template>

<script>

import lodash from 'lodash'
import { mapGetters } from 'vuex'
import * as UrlService from '../../scripts/modules/url'
import * as searchModule from '../../scripts/modules/search'
import * as autocompleteModule from '../../scripts/modules/autocomplete'

export default {
  name: 'search',
  watch: {
    // watch variable with search key to know that user is typing
    'newSearchParamsKey': function(newKey) {
      this.autocompleteGetSuggestions(this.newSearchParams)
      if (!this.activeSuggestions) {
        this.$store.commit('SET_ACTIVE_SUGGEST_TMP', newKey)
      }
    }
  },
  methods: {
    // actions when user is typing
    autocompleteGetSuggestions: _.debounce( function(params) {
        this.status = 'Typed'
        autocompleteModule.getSuggestions(this.$lang.search.form.select.params, params)
    }, 100),
    // rest actions in external files
    autocompleteHighlightLetters: function(suggestion, query) {
      return autocompleteModule.highlightLetters(suggestion, query)
    },
    autocompleteSetSuggestion(value) {
      return autocompleteModule.setSuggestion(this.newSearchParams, value)
    },
    autocompleteKeyHandler(e) {
      return autocompleteModule.keyHandler(e,this.$refs.autocompleteList)
    },
    autocompleteListMouseEnter (e) {
      return autocompleteModule.listMouseEnter(e,this.$refs.autocompleteList)
    },
    autocompleteListMouseLeave (e) {
      return autocompleteModule.listMouseLeave(e)
    },

    newSearchQuery () {
      return searchModule.newSearchQuery(this.newSearchParams)
    },
    onClickOutside (event) {
      return autocompleteModule.setAutocompleteDropdown(true)
    }
  },
  computed: {
    newSearchParamsKey: {
      get () {
        return this.newSearchParams.key
      },
      set (value) {
        this.$store.commit('SET_NEW_SEARCH_PARAMS_KEY', value)
      }
    },
    newSearchParamsParam: {
      get () {
        return this.newSearchParams.param
      },
      set (value) {
        this.$store.commit('SET_NEW_SEARCH_PARAMS_PARAM', value)
      }
    },
    ...mapGetters({
      newSearchParams: 'GET_NEW_SEARCH_PARAMS',
      suggestions: 'GET_SUGGESTIONS',
      activeSuggestTmp: 'GET_ACTIVE_SUGGEST_TMP',
      activeSuggestions: 'GET_IS_ACTIVE_SUGGESTIONS',
      activeAutocompleteDropdown: 'GET_IS_ACTIVE_AUTOCOMPLETE_DROPDOWN'
    })
  }
}
</script>



// WEBPACK FOOTER //
// SearchForm.vue?7968b669